module.exports = __webpack_public_path__ + "img/CMA资质认定证书.png";